import React from "react";
import "./Footer.css";
const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-content container">
                <div className="footer-text">
                    Pulse.exe 2K22 | Made with ❤️ by the IT Department of MCKVIE
                </div>
            </div>
        </div>
    );
};

export default Footer;
